import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Markdown from "components/common/Markdown";
import { ExposureFlagCells } from "components/inputs/flags/ExposureFlags";
import * as labels from "config.labels";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const ExposureFlags = (props) => {
  const hasComments = props.exposures.some(({ comments }) => !!comments);

  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const includeComments = hasComments;

  return (
    <Grid item xs={6}>
      <span className={"print-label"}>
        {translateLabel(labels.PRINT_EXPOSURE_FLAGS_TITLE, {
          default: "Exposure Flags",
        })}
      </span>

      <TableContainer>
        <Table size={"small"} className={"flags"}>
          <TableHead>
            <TableRow>
              <TableCell>
                {translateLabel(labels.EXPOSURE_FLAG_TYPE_COLUMN, {
                  default: "Type",
                })}
              </TableCell>
              <TableCell>
                {translateLabel(labels.EXPOSURE_FLAG_CATEGORY_COLUMN, {
                  default: "Category",
                })}
              </TableCell>
              {includeComments && (
                <TableCell>
                  {translateLabel(labels.EXPOSURE_FLAG_COMMENTS_COLUMN, {
                    default: "Comments",
                  })}
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.exposures.map((flag) => (
              <TableRow key={flag.id}>
                <ExposureFlagCells flag={flag} />
                {includeComments && (
                  <TableCell
                    sx={{ verticalAlign: "top" }}
                    className={"cell-condensed-padding-md"}
                  >
                    <Markdown value={flag.comments} />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default ExposureFlags;
